<template>
  <a-modal
    title="开具信用证"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', this.otherData) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24" v-if="sellContract">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.project }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="货物" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.product_name }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.number }} [ {{ sellContract.name }}]
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              信用证付款信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="mdl && mdl['issuing_bank']">
            <a-form-item label="开证银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ mdl['issuing_bank'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="代开银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="bankFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'debtor_bank_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入银行名称"
                :default-active-first-option="false"
                @search="this.bankSearch"
                @change="handleDebtorBankChange"
              >
                <a-spin v-if="bankFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in bankList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="受益人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ sellContract['client'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['issue_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开证日"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['lc_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'lc_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="溢短装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['more_less_clause', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="溢短装"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金存入日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['margin_deposit_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="保证金存入日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['margin_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'margin_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金到期日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['margin_maturity_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="保证金到期日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金利率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['margin_interest_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="保证金利率"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="到期可用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_available_at_expiry', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="信用证种类" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'lc_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in lcTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="信用证期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" v-decorator="['lc_tenor', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="信用证期限"/> 天
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息（可上传开证报文）
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="20" v-if="otherData.attachment.length > 0">
            <a-table
              bordered
              :data-source="otherData.attachment"
              :columns="attachmentColumns"
              v-if="this.otherData.attachment.length > 0"
              :pagination="false"
              key="key">
              <template slot="action" slot-scope="text, record">
                <a-popconfirm
                  v-if="otherData.attachment.length"
                  title="确定删除?"
                  @confirm="() => onAttachmentDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAttachmentCancel"
        @ok="handleAttachmentOk"
        :visible="attachmentVisible"
        v-if="attachmentVisible"
        :loading="false"
      />
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
import { project_list } from '@/api/trade_project'
import { sell_contract_list } from '@/api/trade_sell_contract'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { lc_application_list } from '@/api/trade_credit_letter'

// 表单字段
const fields = ['id', 'name', 'contact', 'phone', 'mail']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.bankSearch = debounce(this.handleBankSearch, 800)
    this.advisingBankSearch = debounce(this.handleAdvisingBankSearch, 800)
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      mdl: undefined,
      loading: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      projectName: undefined,
      productName: undefined,
      sellContract: undefined,
      bankList: [],
      advisingBankList: [],
      projectList: [],
      sellContractList: [],
      contractList: [],
      projectFetching: false,
      bankFetching: false,
      advisingBankFetching: false,
      selectedSellContract: undefined,
      selectedProjectId: undefined,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      lcTypeList: this.$Dictionaries.trade_lc_types,
      letterCreditTypeList: this.$Dictionaries.letter_credit_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      contractType: 0,
      selectedLetterCreditType: 0,
      accordingContract: true,
      attachmentVisible: false,
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          width: 150,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted () {
    this.loadSellContractInfo()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    moment,
    handleDebtorBankChange (value) {
      console.log('代开银行', value)
    },
    loadSellContractInfo () {
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
          console.log('信用证开始', this.mdl)
        }).finally(() => {
          if (this.mdl !== undefined && this.mdl['sell_contract_id'] !== undefined) {
            this.otherData['issuing_bank_id'] = this.mdl.issuing_bank_id
            this.loading = true
            sell_contract_list({ id: this.mdl['sell_contract_id'] }).then(res => {
              if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
                this.sellContract = res.data.entries[0]
              }
            }).finally(() => {
              this.loading = false
              if (this.sellContract) {
                // 信用证是否已开具，开具的话，获取已开具的
                this.otherData['beneficiary_id'] = this.sellContract.client_ids[0]
              }
            })
          }
      })
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        this.projectList = res.data.entries || []
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleBankSearch (value) {
      this.bankFetching = true
      bank_list({ name: value }).then((res) => {
        this.bankList = res.data.entries || []
      }).finally(() => {
        this.bankFetching = false
      })
    },
    handleAdvisingBankSearch (value) {
      this.advisingBankFetching = true
      bank_list({ name: value }).then((res) => {
        this.advisingBankList = res.data.entries || []
      }).finally(() => {
        this.advisingBankFetching = false
      })
    },
    handleBankChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleBankSearch(value)
      }
    },
    handleAccordingContractChange (value) {
      this.accordingContract = value
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddAttachment () {
      this.attachmentVisible = true
    },
    handleAttachmentCancel () {
      this.attachmentVisible = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachmentOk () {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          // 显示
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.attachmentVisible = false
          form.resetFields()
        }
      })
    }
  }
}
</script>
